// ===============================
//  SEPARATE EXPORT INTENT DETECTOR
// ===============================
export const detectExportIntent = (query: string) => {
    if (!query) return null;

    const q = query.toLowerCase();

    // Detect file format
    let format: "excel" | "csv" | null = null;

    if (q.includes("excel") || q.includes("xlsx") || q.includes("xls"))
        format = "excel";
    if (q.includes("csv"))
        format = "csv";

    // Detect export trigger
    const isExport =
        q.includes("export") ||
        q.includes("download") ||
        q.includes("get file") ||
        q.includes("download report") ||
        q.includes("give me") ||
        (format !== null); // user directly says excel/csv

    if (!isExport) return null;

    let reportType: string | null = null;

    if (q.includes("attendance")) reportType = "attendance_report"
    else if (q.includes("leaveledger")) reportType = "leaveledger";
    else if (q.includes("leave report") || q.includes("leave") || q.includes("leave")) reportType = "leave";
    else if (q.includes("salary") || q.includes("salary report")|| q.includes("slry") ) reportType = "salary";
    else if (q.includes("employee") || q.includes("employee report") || q.includes("employees")) reportType = "employee";
    else if (q.includes("attendance")|| q.includes("attendance report")) reportType = "attendance";
    else if (q.includes("expense") || q.includes("PF") || q.includes("pf") || q.includes("PF report") ) reportType = "expense";
    else if (q.includes("user")|| q.includes("user report")) reportType = "user";
    else if (q.includes("payslip")|| q.includes("payslip report")) reportType = "payslip";
    else if (q.includes("onboarding")|| q.includes("onboarding report")|| q.includes("onboardingreport")) reportType = "employeeReport";
    else if (q.includes("offboarding")|| q.includes("offboarding report")|| q.includes("offboardingreport")) reportType = "offboarding_report";
    else if (q.includes("skills")|| q.includes("skill")|| q.includes("skills report")|| q.includes("organisation skill") ) reportType = "skills";
    else if (q.includes("timesheet")|| q.includes("timesheet report")) reportType = "employee_timesheet";
    else if (q.includes("project")|| q.includes("project report")) reportType = "project_report";
    else if (q.includes("task")) reportType = "task";
    else if (q.includes("budget")) reportType = "budget_report";
    else if (q.includes("asset")||q.includes("asset allocation") ) reportType = "asset_report";
    else if (q.includes("maintenance")||q.includes("asset maintenance")) reportType = "maintenance_report";
    else if (q.includes("training") || q.includes("training report")) reportType = "training_report";
    else if (q.includes("tds")) reportType = "tds_report";
    else if (q.includes("shift") || q.includes("shift report")) reportType = "shift_report";
    else if (q.includes("daily") || q.includes("daily_report")) reportType = "daily_report";
    else if (q.includes("esic") || q.includes("esic_report")) reportType = "esic_report";
    else if (q.includes("timesheet log") || q.includes("timesheetlog") || q.includes("timesheet log report")) reportType = "timesheetlog";

    return {
        intent: "export_report",
        reportType,
        format: format || "excel"
    };
};
